span.fp-text(:class='{"-text-sm": sm}' data-test='relative-time') {{ relativeTime }}
